import React from "react";

export default () => (
	<footer className="w-full h-32 flex justify-center items-center bg-gray-900 text-gray-100"></footer>
);
